import styled from 'styled-components';
import { CommonCard } from '../commonStyles';
import { LinkNavigatorButton } from '../CTA/Buttons';

export const InvestmentCard = styled(CommonCard)`
  height: 172px;
  padding: 20px 10px 20px 30px;
  margin: 0px 20px 20px 0px;
  box-shadow: 0 9px 21px 0 rgba(128, 152, 213, 0.08);
  position: relative;
  @media only screen and (max-width: 990px) {
    height: 168px;
    padding: 20px 10px 20px 15px;
    position: relative;
  }
  @media only screen and (max-width: 576px) {
    height: 140px;
    padding: 10px 10px 10px 10px;
    margin: 0px 0px 20px 0px;
    position: relative;
  }
`;

export const CardHeading = styled.div`
  font-family: ${props =>
    props.grantsFlag
      ? props.theme.fontFamily.berkeleyStd
      : props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  line-height: ${props => props.theme.lineHeight.h4};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.h5};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.h5};
  }
`;

export const CardBalance = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueLight};
  font-size: ${props => props.theme.fontSize.h1};
  line-height: ${props => props.theme.lineHeight.h1};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  color: ${props => props.theme.fontColors.green};
  margin-top: 0.3rem;
  margin-bottom: 1.625rem !important;
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.h3};
    line-height: ${props => props.theme.lineHeight.h3};
    margin-bottom: 3rem !important;
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.h4};
    line-height: ${props => props.theme.lineHeight.h4};
    margin-bottom: 2rem !important;
  }
`;

export const RedirectingLink = styled(LinkNavigatorButton)`
  position: absolute !important;
  bottom: 10px !important;
  @media (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
    position: absolute !important;
    bottom: 10px !important;
  }
  @media (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.h4};
    line-height: ${props => props.theme.lineHeight.h4};
    position: absolute !important;
    bottom: 10px !important;
  }
`;

export const YTDPercentage = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: normal;
  letter-spacing: ${props => props.theme.letterSpacing.point8};
  color: ${props => props.theme.colors.secondaryColor};
`;
